import { Map as ImmutableMap } from 'immutable';
import * as ActionTypes from '../../../actions/ActionTypes';
import CategoryEntity from '../../../records/CategoryEntityRecord';
const getSubcategoriesFromCategoriesOrganization = payload => {
  const allSubcategories = {};
  for (const category of payload.categories) {
    for (const subcategory of category.subcategories || []) {
      allSubcategories[subcategory.id] = CategoryEntity.from(Object.assign({}, subcategory, {
        parentId: category.id.toString()
      }));
    }
  }
  return ImmutableMap(allSubcategories);
};
const updateSubcategoriesFromTranslationSuccess = (state, response) => {
  const {
    categories
  } = response;
  return state.withMutations(newState => {
    categories.forEach(updatedCategory => {
      if (updatedCategory.subcategories) {
        updatedCategory.subcategories.forEach(updatedSubcategory => {
          const id = updatedSubcategory.knowledgeCategoryId.toString();
          const subcategory = newState.get(id);
          if (!subcategory) {
            return; // Don't try to update state if we don't have the subcategory locally
          }
          updatedSubcategory.nameTranslations.forEach(updatedTranslation => {
            const translationLanguage = updatedTranslation.language;
            const translationIndex = subcategory.translations.findIndex(t => t.language === translationLanguage);
            if (translationIndex >= 0) {
              newState.update(id, c => c.setIn(['translations', translationIndex], updatedTranslation));
            } else {
              newState.updateIn([id, 'translations'], translations => translations.push(updatedTranslation));
            }
            if (!newState.getIn([id, 'translatedToLanguages']).includes(translationLanguage)) {
              newState.updateIn([id, 'translatedToLanguages'], languages => languages.concat(translationLanguage));
            }
          });
        });
      }
    });
  });
};
const removeArticle = (state, articleId) => {
  let nextState = state;
  const parentId = nextState.findKey(subCat => subCat.articles.includes(articleId));
  if (parentId) {
    nextState = nextState.updateIn([parentId, 'articles'], articleIds => articleIds.delete(articleIds.indexOf(articleId)));
  }
  return nextState;
};
const insertArticleAtPosition = (state, catId, insertArticleId, targetArticleId, relativePosition) => {
  return state.updateIn([catId, 'articles'], articleIds => articleIds.insert(relativePosition === 'before' ? articleIds.indexOf(targetArticleId) : articleIds.indexOf(targetArticleId) + 1, insertArticleId));
};
const insertArticleAtParentIndex = (state, articleId, parentSubcategoryId, index) => state.updateIn([parentSubcategoryId, 'articles'], articleIds => articleIds.insert(index, articleId));
const insertArticle = (state, subcategoryId, articleId) => state.updateIn([subcategoryId, 'articles'], articleIds => articleIds.push(articleId));
const INITIAL_STATE = ImmutableMap();
export default function subcategories(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.CLEAR_ORGANIZE_STATE:
      return INITIAL_STATE;
    case ActionTypes.UPDATE_CATEGORY_TRANSLATIONS_SUCCESS:
      return updateSubcategoriesFromTranslationSuccess(state, action.payload);
    case ActionTypes.FETCH_TRANSLATED_CATEGORY_ORGANIZATION_BUFFER_SUCCESS:
    case ActionTypes.FETCH_CATEGORY_ORGANIZATION_BUFFER_SUCCESS:
    case ActionTypes.FETCH_TRANSLATED_CATEGORY_ORGANIZATION_SUCCESS:
      return getSubcategoriesFromCategoriesOrganization(action.payload);
    case ActionTypes.UPDATE_ARTICLE_ORDERING_ERROR:
      {
        const {
          revertInfo: {
            articleId,
            originalParentId,
            originalParentIndex
          }
        } = action.payload;
        let nextState = removeArticle(state, articleId);
        const originalParentIsSubcategory = nextState.has(originalParentId);
        if (originalParentIsSubcategory) {
          nextState = insertArticleAtParentIndex(nextState, articleId, originalParentId, originalParentIndex);
        }
        return nextState;
      }
    case ActionTypes.DROP_ARTICLE_ON_ARTICLE:
      {
        const {
          dragArticleId,
          dropArticleId,
          dropPosition
        } = action.payload;
        let nextState = removeArticle(state, dragArticleId);
        const subcategoryContainingTargetArticle = nextState.findKey(subCat => subCat.articles.includes(dropArticleId));
        if (subcategoryContainingTargetArticle) {
          nextState = insertArticleAtPosition(nextState, subcategoryContainingTargetArticle, dragArticleId, dropArticleId, dropPosition);
        }
        return nextState;
      }
    case ActionTypes.DROP_ARTICLE_ON_SUBCATEGORY:
      {
        const {
          dragArticleId,
          dropSubcategoryId
        } = action.payload;
        const nextState = removeArticle(state, dragArticleId);
        return insertArticle(nextState, dropSubcategoryId, dragArticleId);
      }
    case ActionTypes.DROP_ARTICLE_ON_CATEGORY:
      {
        const {
          dragArticleId
        } = action.payload;
        return removeArticle(state, dragArticleId);
      }
    default:
      return state;
  }
}